import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  deleteGalleryById,
  getGalleryById,
} from "../../../redux/actions/gallery.actions";
import ViewHeader from "../../../components/viewHeader/ViewHeader";
import { Constants } from "../../../utils/constants/Constants";
import ViewEditHeader from "../../../components/viewEditHeader/ViewEditHeader";
import { styles } from "./Styles";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Pagination,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Carousel from "react-material-ui-carousel";
import {
  CarrotRightIcon,
  DeleteIcon1,
  TimesIcon,
} from "../../../utils/constants/Icons.constants";
import moment from "moment";
import CustomPopup from "../../../components/customPopup/CustomPopup";
import { SnackBar } from "../../../components/snackbar/SnackBar";

import InfiniteScroll from "react-infinite-scroll-component";

const ViewGallery = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const classes = styles;
  const { data, isLoading } = useSelector((state) => state.gallery);
  const [isVisible, setIsVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [prevIndex, setPrevIndex] = useState("");
  const [prevData, setPrevData] = useState(null);
  const [openError, setOpenErrorMessage] = React.useState(false);
  const [openSucess, setOpenSucessMessage] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [hasMore, setHasMore] = React.useState(true);

  const [page, setPage] = React.useState(1);
  const [result, setResult] = React.useState([]);
  const observerTarget = useRef(null);
  const handleClose = (event, reason) => {
    if (reason === Constants.EVENT_CLICKAWAY) {
      return;
    }
    setOpenErrorMessage(false);
    setOpenSucessMessage(false);
  };
  let dataSnackbar = {
    message,
    handleClose,
    openError,
    openSucess,
  };

  const getGalleryData = (id, page) => {
    dispatch(getGalleryById({ id, page, page_size: 16 }))
      .unwrap()
      .then((res) => {
        if (res.links.next === null) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }

        setResult((prev) => [...prev, ...res.result]);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getGalleryData(id, page);
  }, [page]);

  const Image = styled("img")(({ theme }) => ({
    height: "155px",
    width: "155px",
    borderRadius: "8px",
    objectFit: "cover",
    cursor: "pointer",
    position: "relative",
    ":hover": {
      border: " 2px solid #86D1BB",
      padding: "5px",
    },
  }));
  const Video = styled("video")(({ theme }) => ({
    height: "155px",
    width: "155px",
    borderRadius: "8px",
    objectFit: "cover",
    cursor: "pointer",
    position: "relative",
    ":hover": {
      border: " 2px solid #86D1BB",
      padding: "5px",
    },
  }));

  const handleVisible = (i) => {
    handleIndex(i);
    setIsVisible((prev) => (prev = true));
  };

  const handleCloseVisible = () => {
    setIsVisible(false);
    setPrevIndex("");
    setPrevData(null);
  };

  const handleDeleteImage = (imageData) => {
    setOpen(true);
  };

  const handleConfirm = () => {
    setOpen(false);
    if (prevIndex === result.length - 1) handleIndex(prevIndex - 1);

    dispatch(deleteGalleryById(prevData.media_file_id))
      .unwrap()
      .then((data) => {
        if (result.length === 1) {
          setIsVisible(false);
        }
        setResult((prev) => prev.filter((item, i) => i !== prevIndex));

        setOpenSucessMessage(true);
        setMessage(data?.message);
      })
      .catch((err) => {});
  };

  const handleIndex = (i) => {
    setPrevIndex(i);
    setPrevData(result[i]);
  };

  const fileName =
    prevData?.media_file?.split("/")[
      prevData?.media_file?.split("/").length - 1
    ];

  const handleTablePageChange = () => {
    setPage(page + 1);
  };
  if (isLoading && page === 1) {
    return (
      <Box
        display={"flex"}
        alignContent={"center"}
        justifyContent={"center"}
        height={"100vh"}
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <div>
      <SnackBar {...dataSnackbar} />
      {open && (
        <CustomPopup
          title={Constants.TITLE_DELETE_IMAGE}
          open={open}
          handleClose={() => setOpen(false)}
          warning={Constants.DELETE_WARNING + fileName}
          handleConfirm={handleConfirm}
        />
      )}
      <ViewHeader
        onlyHeading={true}
        heading={Constants.HEADING_TEXT_VIEW_GALLERY}
      />
      <ViewEditHeader title={data?.name} />
      <Box sx={{ ...classes.root }}>
        {result?.length === 0 ? (
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Typography>{Constants.TEXT_NO_RECORDS}</Typography>
          </Box>
        ) : isVisible ? (
          <Box display={"flex"}>
            <Box flex={3} position={"relative"}>
              <Carousel
                next={(next) => handleIndex(next)}
                prev={(prev) => handleIndex(prev)}
                indicators={false}
                autoPlay={false}
                navButtonsAlwaysVisible={true}
                navButtonsAlwaysInvisible={false}
                index={prevIndex}
                strictIndexing={false}
                navButtonsWrapperProps={{
                  style: {
                    height: "80%",
                  },
                }}
                navButtonsProps={{
                  style: {
                    backgroundColor: "white",
                    color: "#86D1BB",
                  },
                }}
                sx={classes.carousel}
              >
                {result?.map((media, i) => (
                  <Fragment key={media?.media_file_id}>
                    {media?.media_type === Constants.MEDIA_TYPE_VIDEO ? (
                      <video style={{ ...classes.img }} controls>
                        <source src={media?.media_file} type="video/mp4" />
                      </video>
                    ) : (
                      <img
                        loading="lazy"
                        src={media?.media_file}
                        alt=""
                        style={classes.img}
                      />
                    )}
                  </Fragment>
                ))}
              </Carousel>
              <IconButton
                style={classes.closeIcon}
                size="small"
                onClick={handleCloseVisible}
              >
                <TimesIcon />
              </IconButton>
            </Box>
            <Box
              flex={1}
              padding={"0px 30px"}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"flex-start"}
              gap={"20px"}
            >
              <Box>
                <Typography style={classes.textGrey} gutterBottom>
                  {prevData?.media_type === Constants.MEDIA_TYPE_VIDEO
                    ? "Video"
                    : "Image"}{" "}
                  Name
                </Typography>
                <Box maxWidth="24rem">
                  <Typography>{fileName}</Typography>
                </Box>
              </Box>
              <Box>
                <Typography style={classes.textGrey} gutterBottom>
                  {prevData?.media_type === Constants.MEDIA_TYPE_VIDEO
                    ? "Video"
                    : "Image"}{" "}
                  Date
                </Typography>
                <Typography>
                  {moment(prevData?.created_at).format("MMMM DD, YYYY")}
                </Typography>
              </Box>

              <IconButton
                onClick={() => handleDeleteImage(prevData)}
                disabled={isLoading}
              >
                <DeleteIcon1 />
              </IconButton>
            </Box>
          </Box>
        ) : (
          <Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              gap="15px"
              flexWrap={"wrap"}
            >
              {result?.map((media, i) =>
                media?.media_type === Constants.MEDIA_TYPE_VIDEO ? (
                  <Box position={"relative"} key={media?.media_file_id}>
                    <Video
                      loading="lazy"
                      onClick={() => handleVisible(i)}
                      src={media?.media_file}
                      alt=""
                      key={media?.media_file_id}
                    ></Video>
                    <Box
                      sx={{ ...classes.playBtn, paddingLeft: "13px" }}
                      size="small"
                      onClick={() => handleVisible(i)}
                    >
                      <CarrotRightIcon />
                    </Box>
                  </Box>
                ) : (
                  <Image
                    loading="lazy"
                    onClick={() => handleVisible(i)}
                    src={media?.media_file}
                    alt=""
                    key={media?.media_file_id}
                  />
                )
              )}
            </Box>

            <Box
              marginTop={2}
              display={hasMore ? "flex" : "none"}
              justifyContent={"center"}
              flexDirection={"column"}
              alignItems={"center"}
              overflow={"hidden"}
            >
              {isLoading ? (
                <CircularProgress />
              ) : (
                <Button
                  variant="outlined"
                  sx={{ borderRadius: "5px" }}
                  onClick={handleTablePageChange}
                >
                  {Constants.LOAD_MORE}
                </Button>
              )}
            </Box>
          </Box>
        )}
        <Box>
          <Typography align="center" style={classes.count} sx={{ mt: 2 }}>
            Showing {result?.length} of {data?.count} Assets
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default ViewGallery;
